import React, { createContext } from 'react';

const PrivilegesContext = createContext({});

export default PrivilegesContext;

export const PrivilegesContextProvider = ({ privileges, children }) => (
  <PrivilegesContext.Provider value={privileges}>{children}</PrivilegesContext.Provider>
);
